import { applyStoredAppearance } from './apply-appearance';
import { applyStoredTypography } from './typography';

/** Head entry. Runs before the app bundle so the first styled paint already has `.dark`. */
applyStoredAppearance(document.documentElement);
applyStoredTypography(document.documentElement, window.location.pathname);
